import { combineReducers } from "redux";
import { appTokenReducer } from './appToken/appTokenIndex';
import { rootDetectionReducer } from './rootDetection/rootDetectionIndex';
import { loyaltyProgramReducer } from './loyalty/program/loyaltyProgramIndex';
import { loyaltyNotificationsReducer } from './loyalty/notifications/loyaltyNotificationsIndex';
import { loyaltyToastReducer } from './loyalty/toast/loyaltyToastIndex';
import { loyaltyLocationsReducer } from './loyalty/locations/loyaltyLocationsIndex';
import { loyaltyMembersReducer } from './loyalty/members/loyaltyMembersIndex';
import { loyaltyRewardsReducer } from './loyalty/rewards/loyaltyRewardsIndex';
import { loyaltyAutomatedRewardsReducer } from './loyalty/automatedRewards/loyaltyAutomatedRewardsIndex';
import { productCatalogReducer } from './productCatalog/productCatalogReducer';
import { displayReducer } from './display/display/displayIndex';
import { mediaLibraryReducer } from './display/mediaLibrary/mediaLibraryIndex';
import { playlistReducer } from './display/playlist/playlistIndex';
import { clickHouseReducer } from './reports/clickHouse/clickHouseIndex';
import { ReportsChatbotReducer } from './reports/ReportsChatbot/ReportsChatbotIndex';
import { reservationReportReducer } from './reports/reservationReport/reservationReportIndex';
import { reportFiltersReducer } from './reportFilters/reportFiltersIndex';
import { offersReportReducer } from './reports/offersReport/offersReportIndex';
import { RESET_REPORTS_DATA } from './globalActions';
import { offerManagementReducer } from './offers/offerReducer';
import { cateringReducer } from './catering/cateringReducer';

const appReducer = combineReducers({
  appToken: appTokenReducer,
  rootDetection: rootDetectionReducer,
  loyaltyProgram: loyaltyProgramReducer,
  loyaltyNotifications: loyaltyNotificationsReducer,
  loyaltyToast: loyaltyToastReducer,
  loyaltyLocations: loyaltyLocationsReducer,
  loyaltyMembers: loyaltyMembersReducer,
  loyaltyRewards: loyaltyRewardsReducer,
  loyaltyAutomatedRewards: loyaltyAutomatedRewardsReducer,
  productCatalog: productCatalogReducer,
  display: displayReducer,
  mediaLibrary: mediaLibraryReducer,
  playlist: playlistReducer,
  clickHouse: clickHouseReducer,
  ReportsChatbot: ReportsChatbotReducer,
  reservationReport: reservationReportReducer,
  offersReport: offersReportReducer,
  reportFilters: reportFiltersReducer,
  offerManagement: offerManagementReducer,
  catering: cateringReducer,
});

// data so a different account never sees the prior session's numbers. Setting
// these slices to `undefined` makes combineReducers reinitialize each one to
// its own initialState. Device/app-level slices (appToken, rootDetection) are
// intentionally left untouched.
const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_REPORTS_DATA && state) {
    state = {
      ...state,
      clickHouse: undefined,
      reservationReport: undefined,
      ReportsChatbot: undefined,
      offersReport: undefined,
      reportFilters: undefined,
    };
  }
  return appReducer(state, action);
};

export { rootReducer };

export type RootState = ReturnType<typeof appReducer>;
